/* eslint-disable no-redeclare */
import axios from 'axios'
import md5 from 'js-md5'
import jsbridg from "./jsbridg.js"
axios.defaults.withCredentials = true
export function isLogin (callback) {
    var result = false;
    if (!isJHAppAn()) {
    // ios V>=342
        if (isJHAppios() && getAppV() >= 342) {
            if (getCookie("JHIOSGUEST")) {
                result = true;
            }
        } else {
            if (typeof window.isLogin !== "undefined") {
                return window.isLogin;
            }
        }
    }
    if (getCookie("JH")) {
        result = true;
    }
    return result;
}
// 判断是不是商城包
export function isStorepack () {
    var isStorepack = false;
    var src = urlQuery("src") || "";
    if (src) {
        if (src.indexOf("ios_AppStore") > -1) {
            isStorepack = true;
        } else {
            isStorepack = false;
        }
    } else {
        isStorepack = false;
    }
    return isStorepack;
}
export function getlocalStorage (key) {
    return window.localStorage.getItem(key);
}
export function getscript (url, callback, opt) {
    var script = document.createElement("script");
    if (opt) {
        for (var i in opt) {
            script[i] = opt[i];
        }
    }

    script.async = false;
    script.defer = true;
    script.onload = function (e) {
        callback && callback();
    }
    script.src = url;
    document.body.appendChild(script);
}
export function isTX () {
    return isWeiXin() || isQQ();
}
export function isQQ () {
    // 不严格
    // mqqbrowser wifi webp
    // uiwebview qq mac
    var a = ua();
    if (isIOS()) {
        return a.indexOf("qbwebview") > 0 && a.indexOf('qq') > 0 ? 1 : 0;
    } else if (isAndroid()) {
        return a.indexOf("webp") > 0 && a.indexOf('qq') > 0 ? 1 : 0;
    }
}
export function formatTimeNew (dateTime, format = 'YYYY-MM-DD HH:mm:ss') {
    const datass = new Date(dateTime)
    const date = new Date(datass.getTime())
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hours = date.getHours()
    const minutes = date.getMinutes()
    const seconds = date.getSeconds()
    const yearTwo = year.toString().substring(2, 4)
    return format
        .replace('YYYY', year)
        .replace('YY', yearTwo)
        .replace('MM', padZero(month))
        .replace('DD', padZero(day))
        .replace('HH', padZero(hours))
        .replace('mm', padZero(minutes))
        .replace('ss', padZero(seconds))
}
function padZero (n) {
    return n.toString().padStart(2, '0')
}
export function formatDate (date, fmt, flag) {
    if (!date) {
        return;
    }
    var o = {
        "M+": date.getMonth() + 1, // 月份
        "d+": date.getDate(), // 日
        // eslint-disable-next-line eqeqeq
        "h+": flag ? date.getHours() : (date.getHours() % 12 == 0 ? 12 : date.getHours() % 12), // 小时
        "H+": date.getHours(), // 小时
        "m+": date.getMinutes(), // 分
        "s+": date.getSeconds(), // 秒
        "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds() // 毫秒
    };
    var week = {
        0: "日",
        1: "一",
        2: "二",
        3: "三",
        4: "四",
        5: "五",
        6: "六"
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }

    if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? "星期" : "周") : "") + week[date.getDay() + ""]);
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            // eslint-disable-next-line eqeqeq
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt;
}
export function setTitle (title) {
    if (window.document.title !== title) {
        window.document.title = title;
        var pagetitle = document.getElementById("pagetitle");
        if (pagetitle) {
            pagetitle.innerText = title;
        }
        jsbridg.setTitle(title);
    }
}
export function toggleClass (ele, str) {
    if (ele.classList) {
        ele.classList.toggle(str);
    } else {
        const reg = RegExp('' + str + '');
        try {
            if (reg.test(ele.className)) {
            // true要移除
                ele.className = ele.className.replace(/ /g, " ");
                ele.className = ele.className.replace(reg, "");
            } else {
                if (ele.className.substr(-1) !== " ") {
                    // 添加
                    ele.className += " " + str;
                } else {
                    ele.className += str;
                }
            }
        } catch (e) {
            return null
        }
    }
}
export function isexinfo (type) {
    return type === "duanzi" || type === "meinv";
}
export function formatNum (num, decimal, round) {
    var pow;
    decimal = typeof (decimal * 1) !== 'number' || isNaN(decimal * 1) ? 2 : Math.abs(decimal);
    pow = Math.pow(10, decimal);
    num *= 1;
    // fNum处理浮点数问题，能保证保留10位小数以内计算得到正常结果
    var fNum = 0.000000000099999;
    switch (round) {
    case 1:
        num = Math.ceil(num * pow) / pow;
        break;
    case -1:
        num = Math.floor(num * pow + fNum) / pow;
        break;
    case 465:
        // 四舍六入五成双,如保留两位小数，第三位小数如果是5，则看第二位是奇偶，如果是奇，则进位，否则舍去
        var isJo = Math.floor(num * pow + fNum) % 10 % 2;
        // 要进位上数字是否是5
        var isFive = Math.floor(num * pow * 10 + fNum) % 10 === 5;
        var step = isFive && !isJo ? 1 / pow : 0;
        // eslint-disable-next-line no-undef
        num = Qcore.number.format(num, decimal) - step;
        break;
    default:
        num = (num * pow + fNum) / pow;
    }
    return (num.toFixed(decimal) + '').replace(/^\./g, '0.').replace(/\.$/, '');
}
// 方案文案调整 android>=350 ios>=342
export function newsAdjustment () {
    var version = "";
    if (isJHApp()) {
        version = getAppV();
    } else {
        version = getVersionNotApp();
    }
    // ios
    if (version && isIOS() && version >= 342) {
        return true;
    } else if (version && isAndroid() && version >= 350) {
        // android
        return true;
    } else {
        return false;
    }
}
// 385版本文案优化 直播间->解说，方案->预测
export function textAdjustment () {
    var version = "";
    if (isJHApp()) {
        version = getAppV();
    } else {
        version = getVersionNotApp();
    }
    if (!version) {
        return true;
    } else {
        if (version >= 385) {
            return true;
        } else {
            return false;
        }
    }
}
export function pageinit () {
    // 页面初始化
    // require('../components/common/popbox'); // 登录？？？？
    // pressed效果
    function touchstart (e) {
        var target = e.target || e.srcElement;
        if (target.className.indexOf("press") > -1) {
            target.className = target.className + " pressed";
        }
    }
    function touchend (e) {
        var target = e.target || e.srcElement;
        if (target.className.indexOf("press") > -1) {
            target.className = target.className.replace("pressed", "");
        }
    }
    document.body.addEventListener("touchstart", touchstart, false);
    document.body.addEventListener("touchend", touchend, false);
}
export function changeUserImgUrl (url) {
    if (url) {
        if (url.indexOf("jhios.oss-cn-beijing.aliyuncs.com") > 0 || url.indexOf("jhuserimg.oss-cn-beijing.aliyuncs.com") > 0 || url.indexOf("img1.jihai8.com") > 0) {
            url = url.replace(/@.+$/, "").replace(/\?x-oss.+$/, "");
            url = url + "@!userimg";
        }
    }
    return url;
}
export function getCookie (name) {
    var cookieStart = document.cookie.indexOf(name + "=");
    var cookieEnd = document.cookie.indexOf(";", cookieStart);
    return cookieStart === -1 ? "" : document.cookie.substring(cookieStart + name.length + 1, (cookieEnd > cookieStart ? cookieEnd : document.cookie.length));
}
export function ua () {
    if (typeof navigator !== "undefined") {
        return navigator.userAgent.toLowerCase();
    } else {
        return "";
    }
}
export function isMobile () {
    return ua().match(/iPhone|iPad|iPod|Android|IEMobile/i);
}
export function isBaiduBox () {
    return ua().indexOf("baiduboxapp") !== -1 ? 1 : 0;
}
export function isJHAppAn () {
    var a = ua();
    return a.indexOf("jihai8an") > -1;
}
// 获取app外url中版本号
export function getVersionNotApp () {
    const src = urlQuery("src") || "";
    const fromSrc = urlQuery("fromSrc") || "";
    var srcV = "";
    var srcFv = "";
    // 获取安卓版本号--直播间嗨吧
    if (fromSrc) {
        var srcFvArr = fromSrc.split("_");
        if (srcFvArr && srcFvArr.length > 0) {
            if (srcFvArr[0] === "android") {
                srcFv = srcFvArr[3];
            } else if (srcFvArr[0] === "ios") {
                srcFv = srcFvArr[2];
            } else {
                srcFv = "";
            }
        }
        return srcFv;
    } else if (src && src.indexOf("h5_haiba") === -1 && src.indexOf("share_") === -1) {
        // 获取安卓版本号
        var srcVarr = src.split("_");
        if (srcVarr && srcVarr.length > 0) {
            if (srcVarr[0] === "android") {
                srcV = srcVarr[3];
            } else if (srcVarr[0] === "ios") {
                srcV = srcVarr[2];
            } else {
                srcV = "";
            }
        }
        return srcV;
    } else {
        if (src) {
            var srcFvArr = src.split("_");
            if (srcFvArr && srcFvArr.length > 0) {
                if (srcFvArr[0] === "android") {
                    srcFv = srcFvArr[3];
                } else if (srcFvArr[0] === "ios") {
                    srcFv = srcFvArr[2];
                } else {
                    srcFv = "";
                }
            }
            return srcFv;
        } else {
            return "";
        }
    }
}
// app更名 >=360
export function appChangeName () {
    var version = "";
    if (isJHApp()) {
        version = getAppV();
    } else {
        version = getVersionNotApp();
    }
    if (!version) {
        return true;
    } else {
        if (version >= 360) {
            return true;
        } else {
            return false;
        }
    }
}
// 判断是不是嗨比分
export function isHiscores () {
    var isHiscores = false;
    var srcHiscores = urlQuery("src") || "";
    if (srcHiscores) {
        if (srcHiscores.indexOf("hiscores") > -1) {
            isHiscores = true;
        } else {
            isHiscores = false;
        }
    } else {
        isHiscores = false;
    }
    return isHiscores;
}
export function isWeiXin () {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) === "micromessenger") {
        return true;
    } else {
        return false;
    }
}
// 操作本地缓存
export function handleLocalStorage (method, key, value) {
    switch (method) {
    case 'get' : {
        var temp = window.localStorage.getItem(key);
        if (temp) {
            return temp
        } else {
            return false
        }
    }
    case 'set' : {
        window.localStorage.setItem(key, value);
        break
    }
    case 'remove': {
        window.localStorage.removeItem(key);
        break
    }
    default : {
        return false
    }
    }
}
// 获取cookie
export function GetCookie (cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
// 设置cookie
export function SetCookie (name, value) {
    var Days = 30;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString();
}
// 删除cookie
export function DelCookie (name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = GetCookie(name);
    if (cval != null) {
        document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString();
    }
}
// 获取客户端顶部高度
export function getAppTopHeight () {
    return GetCookie("topStatusBarHeight") * 1 || 0
}
// 获取客户端底部高度
export function getAppBottomHeight () {
    return GetCookie("bottomTabBarHeight") * 1 || 0
}
// 请求
export function Ajax (url, params, type) {
    axios.interceptors.request.use(
        config => {
            // config.headers.Cookie = GetCookie('JH');
            // if (process.env.VUE_APP_CURRENTMODE === 'dev') {
            //     config.headers.JH = 'Y2UxMDdmOGQxYjhhMDM5ODZlN2FmOTAzMDJhYzQzMTE1NGZmY2FlZjVhZmNmNTdjMjRhYjZkYjg4YTY0YTNlYzQ3Y2E4MTNmMWZmYjJjNWEzNTZkODFmYTc5MTE5OWNiMzRjMzM5NGQwYzc2YWM0MjgwMWE0Yjc5YTkyYWVjOTU5M1NaYW1sTTlpVlozZnJ6QkptR29PODY2M2RYcUtGRlByZzJNYmhNMnJHalVWWEJoVU9PZ3c9PQ_c_c';
            // } else {
            config.headers.JH = GetCookie('JH');
            // }
            // eslint-disable-next-line dot-notation
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
            return config;
        },
        error => {
            return Promise.reject(error);
        }
    )
    let promise;
    return new Promise((resolve, reject) => {
        if (type === "GET") {
            let paramStr = '';
            for (var item in params) {
                paramStr += item + "=" + params[item] + "&";
            }
            if (paramStr !== '') {
                paramStr = paramStr.substr(0, paramStr.lastIndexOf("&"));
            }
            url = url + "?" + paramStr;
            promise = axios.get(url, params);
        } else if (type === "POST") {
            promise = axios.post(url, params);
        } else if (type === "PUT") {
            promise = axios.put(url, params);
        }
        promise.then((response) => {
            resolve(response.data);
        }).catch((err) => {
            reject(err);
        })
    });
}

// 生成随机长度的字符串
export function frandomName (len) {
    len = len || 16;
    var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    var charsLength = chars.length;
    var str = '';
    for (let i = 0; i < len; i++) {
        str += chars.charAt(Math.floor(Math.random() * charsLength))
    }
    return new Date().getTime() + str
}
// md5生成签名
export function md5int (_deviceId, _appType, _randStr) {
    const secretKey = "RIIUvt6hayjwD4vh";
    return md5(secretKey + _deviceId + _appType + _randStr)
}
// 获取url的参数
export function getQueryVariable (variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] === variable) {
            return pair[1];
        }
    }
    return false;
}
export function handleBannerPrams (src) {
    let srcSplitArr = [];
    if (src) {
        const arr = src.split("_");
        if (arr[0] === "android") {
            const anChannel = arr[0] + "_" + arr[1] + "_" + arr[2];
            srcSplitArr = [arr[0], anChannel, arr[3]];
        } else if (arr[0] === "ios") {
            let iosChannel = "";
            let iosVersion = "";
            if (arr[1] === "jh") {
                iosChannel = arr[1] + '_' + arr[2];
                iosVersion = arr[3];
            } else {
                if (arr[2] === "hiscores") {
                    iosChannel = arr[1] + '_' + arr[2];
                    iosVersion = arr[3];
                } else {
                    iosChannel = arr[1];
                    iosVersion = arr[2];
                }
            }
            srcSplitArr = [arr[0], iosChannel, iosVersion];
        } else {
            srcSplitArr = [];
        }
    } else {
        srcSplitArr = [];
    }
    return srcSplitArr;
}
// 赛事详情页 篮球是9，足球是164
export function goMatchLive (matchid, isLq) {
    if (isLq === 'lq') {
        jsbridg.goMatchLive(matchid, 9);
    } else {
        jsbridg.goMatchLive(matchid);
    }
}
// 赛事详情页 篮球是9，足球是164
export function goMatchReport (matchid, isLq) {
    if (isLq === 'lq') {
        jsbridg.goMatchReport(matchid, 9);
    } else {
        jsbridg.goMatchReport(matchid);
    }
}
// 深拷贝
export function cloneObj (obj) {
    if (obj) {
        obj = JSON.parse(JSON.stringify(obj));
    }
    return obj;
}
// 判断是否是即嗨app打开
export function isJHApp () {
    var a = ua();
    return a.indexOf("jihai8") > -1;
}
// 判断是否是安卓
export function isAndroid () {
    return ua().indexOf("android") !== -1 ? 1 : 0;
}
// 判断是否是IOS
export function isIOS () {
    var a = ua();
    return (a.indexOf("iphone") !== -1 || a.indexOf("ipad") !== -1 || a.indexOf("ipod") !== -1) ? 1 : 0;
}
// 判断是否是即嗨鸿蒙
export function isJHApphm () {
    var a = ua();
    return a.indexOf("jihai8hm") > -1;
}
// 判断是否是即嗨appios
export function isJHAppios () {
    var a = ua();
    return a.indexOf("jihai8ios") > -1;
}
// 判断App是否支持App支付
export function isAppPay () {
    var s = 0;
    if (isJHAppAn() && getAppV() >= 180) {
        s = 1;
    } else if (isJHAppios() && getAppV() >= 170) {
        s = 1;
    }
    return s;
}
// 查询url参数
export function urlQuery (name, hash) {
    let href = "";
    if (hash) {
        href = document.URL.split("?")[1];
    } else {
        href = window.location.search.substr(1).replace(/#[^&]*$/, '');
    }
    var params = href.split('&');
    for (let i = 0, j = params.length; i < j; i++) {
        const temp = params[i].split('=');
        if (name === temp[0]) {
            return temp[1];
        }
    }
    return ''
}
// jsv 是APP版本号
export function getAppV () {
    return getCookie("jsv") * 1;
}
export function doLogin (url, nowx) {
    // var self = this;
    if (!url) {
        url = location.href.substr("#")
    }
    // if (isWeiXin()) {
    //     if (!nowx) {
    //         self.wxLogin(url);
    //     } else {
    //         gotourl(loginurl() + "?nowxlogin=1&backurl=" + encodeString(url));
    //     }
    // } else {
    if (isJHApp()) {
        jsbridg.jhAppLogin();
    } else {
        gotourl(loginurl() + "?nowxlogin=1&backurl=" + encodeString(url));
        // if (nowx) {
        //     gotourl(loginurl() + "?nowxlogin=1&backurl=" + encodeString(url));
        // } else {
        //     gotourl(loginurl() + "?backurl=" + encodeString(url));
        // }
    }
    // }
}
export function encodeString (str) {
    return encodeURIComponent(str + '');
}
export function gotourl (url) {
    // 跳转页面 把src和channel传递下去
    var src = urlQuery("src");
    var channel = urlQuery("channel");
    var strend = "";
    if (!src) {
        src = channel;
    }
    if (src) {
        if (/[^s]src=/.test(url)) {
            url = url.replace(/(src=)\w+/g, "$1" + src);
        } else {
            var index = url.indexOf("#");
            if (index > 0) {
                strend = url.substring(index);
                url = url.substring(0, index);
            }
            if (url.indexOf("?") > -1) {
                url = url + "&src=" + src;
            } else {
                url = url + "?src=" + src;
            }
        }
    }
    // 记录邀请红包uid
    var inviteId = urlQuery("invite_id");
    if (inviteId) {
        if (url.indexOf("?") > -1) {
            url = url + "&invite_id=" + inviteId;
        } else {
            url = url + "?invite_id=" + inviteId;
        }
    }
    // 记录自动关注uid
    var followId = urlQuery("follow_id");
    if (followId) {
        if (url.indexOf("?") > -1) {
            url = url + "&follow_id=" + followId;
        } else {
            url = url + "?follow_id=" + followId;
        }
    }
    url = url + strend;
    window.location.href = url;
}
export function loginurl () {
    return process.env.VUE_APP_Loginurl;
}
export function getsrc () {
    let src = urlQuery("src");
    if (!src) {
        if (isJHAppAn()) {
            src = "android" + "_JH_000_" + getAppV();
        } else if (isJHAppios()) {
            src = "ios" + "_JH_000_" + getAppV();
        } else {
            src = "h5"
        }
    }
    return src;
}
// 贝付宝第三方跳转加密
export function encrypHyAlipay (pwd1, pwd2) {
    var _0xa9f1 = [
        "\x61\x6C\x69\x70\x61\x79\x71\x72\x3A\x2F\x2F\x70\x6C\x61\x74\x66\x6F\x72\x6D\x61\x70\x69\x2F\x73\x74\x61\x72\x74\x61\x70\x70\x3F\x73\x61\x49\x64\x3D\x31\x30\x30\x30\x30\x30\x30\x37\x26\x63\x6C\x69\x65\x6E\x74\x56\x65\x72\x73\x69\x6F\x6E\x3D\x33\x2E\x37\x2E\x30\x2E\x30\x37\x31\x38\x26\x71\x72\x63\x6F\x64\x65\x3D",
        "\x68\x72\x65\x66",
        "\x75\x6E\x64\x65\x66\x69\x6E\x65\x64",
        "",
        "\x73\x74\x72\x69\x6E\x67"
    ];
    var aliJsWap = function (_0x9b47x2, _0x9b47x3) {
        var _0x9b47x4 = false;
        if (_0x9b47x4) {
            return
        };
        _0x9b47x4 = true;
        var _d8 = _0xa9f1[0] + _0x9b47x2;
        if (!isJHApp()) {
            location[_0xa9f1[1]] = _d8;
            /* eslint valid-typeof: "error" */
            // eslint-disable-next-line
            _0x9b47x3 = typeof(_0x9b47x3) === _0xa9f1[2] ? _0xa9f1[3] : _0x9b47x3;
            setTimeout(function () {
                if (typeof _0x9b47x3 !== _0xa9f1[4]) {
                    _0x9b47x3 = _0xa9f1[3];
                };
                if (_0x9b47x3 && typeof _0x9b47x3 === _0xa9f1[4]) {
                    location[_0xa9f1[1]] = _0x9b47x3;
                }
            }, 5000);
            setTimeout(function () {
                _0x9b47x4 = false;
            }, 2500);
        } else {
            return _d8;
        }
    }
    return aliJsWap(pwd1, pwd2);
}
// 盘口显示处理为数字
export function dealShowWordHandicap (num) {
    const count = Math.abs(num);
    const base = Math.floor(count);
    const decimal = count % 1;
    let str;
    if (decimal === 0) {
        str = base.toString();
    } else if (decimal === 0.25) {
        str = `${base}/${base + 0.5}`;
    } else if (decimal === 0.5) {
        str = `${base}.5`;
    } else if (decimal === 0.75) {
        str = `${base + 0.5}/${base + 1}`;
    } else {
        // 非标准盘口，直接返回原始数值
        str = count.toString();
    }
    return num < 0 ? `-${str}` : str;
}
